import { render } from "./ComparatorItem.vue?vue&type=template&id=1a3fb320&scoped=true&ts=true"
import script from "./ComparatorItem.vue?vue&type=script&lang=ts"
export * from "./ComparatorItem.vue?vue&type=script&lang=ts"

import "./ComparatorItem.vue?vue&type=style&index=0&id=1a3fb320&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3fb320"]])

export default __exports__